<template>
  <div class="arrangement">
    <iframe
      src="https://case.11dom.com/thg/"
      scrolling="no"
      border="0"
      frameborder="no"
      framespacing="0"
      allowfullscreen="true"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'arrangement',
  components: {},
  props: [],
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.arrangement {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
    border-radius: 2px;
  }
}
</style>